<template>
  <CommonButton
    data-testid="button-book-a-demo"
    :class="twMerge('text-sm', ($attrs.class as string) || '')"
    @click="bookADemo"
  >
    {{ label }}
  </CommonButton>
</template>

<script setup lang="ts">
import { twMerge } from 'tailwind-merge'
import { useRoute } from '#app'

import CommonButton from '~/components/common/Button.vue'

withDefaults(
  defineProps<{
    label?: string
  }>(),
  {
    label: 'Book a Demo',
  },
)

const { $config } = useNuxtApp()
const router = useRoute()

const bookADemo = () => {
  const data = { form_completed_on: router.fullPath }
  const queryString = new URLSearchParams(data).toString()
  const url = `${$config.public.app.productionUrl}/book-a-demo?${queryString}`

  window.open(url, '_blank', 'noopener,noreferrer')
}
</script>
